import React from "react";
import {createUseStyles} from "react-jss";
import {useScrollytellTranslation} from "../Admin/scrollytellContext";

const useStyles = createUseStyles({
    buttonContainer: {
        display: "flex",
        justifyContent: "center",
        marginTop: "20px",
        marginBottom: "20px",
        minHeight: "52px"
    },
    button: {
        border: "none",
        outline: "none",
        display: "inline-flex",
        padding: "11px 24px",
        minHeight: "44px",
        minWidth: "44px",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        borderRadius: "999px",
        background: "#3F3F3F",
        color: "#FFF",
        textAlign: "center",
        fontFamily: "Roboto",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "160%",
        letterSpacing: "0.024px",
        cursor: "pointer",
        "&:hover": {
            transform: "scale(1.05) rotate(-1deg)"
        },
        "&:focus-visible": {
            outline: "2px solid #4484F1",
            outlineOffset: "2px",
        },
    }
})

export const RetryButton = ({show, onClick}) => {
    const classes = useStyles()
    const tHook = useScrollytellTranslation();
    const t = typeof tHook === "function" ? tHook : (k, fb) => fb || k;

    if(show) {
        return (
            <div
                className={classes.buttonContainer}
            >
                <button
                    type={"button"}
                    className={classes.button}
                    onClick={onClick}
                >
                    {t("retryButton", "Prøv igjen")}
                </button>
            </div>
        )
    } else {
        return (
            <div
                className={classes.buttonContainer}
            >
            </div>
        )
    }
}
